import { render } from "./index.vue?vue&type=template&id=dc0503cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=dc0503cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc0503cc"],['__file',"src/views/Faqs/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc0503cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc0503cc', __exports__)) {
    api.reload('dc0503cc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=dc0503cc&scoped=true", () => {
    api.rerender('dc0503cc', render)
  })

}


export default __exports__